// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1MEbR","labelContainer":"styles_labelContainer__1-KyA","label":"styles_label__1czJ9","buttonsContainer":"styles_buttonsContainer__1hOsd"};